<template lang="pug">
#approval-body
  van-nav-bar.approval-nav( title='发起审批' left-text='返回' v-if="!isProject" left-arrow @click-left='onClickLeft' @click-right='onClickRight')
  .approval-bg(ref="vanImage")
    van-image(width="100%" height="100%" fit="cover" :src="approvalBg"  @click.native="goApproval")
  .approval-main
    van-tabs(v-model="active" title-active-color="#3873FE" scrollspy ellipsis sticky color="#3873FE" :offset-top="offsetTop")
      van-tab(v-for="(item,index) in tabData" :key="index" :title="item.flowGroupDto.name")
        .main-tabs
          span(class="tabs-title") {{item.flowGroupDto.name}}
          van-grid(:column-num="3" :border="false")
            van-grid-item(v-for="cc in item.flowDefinitionDtoList" :key="cc.id" @click.native="goApproval(cc)")
              van-image(:src="showIcon(cc.iconPrefix)")
              span(class="grid-name") {{cc.name}}
</template>
<script>
import { mapState } from "vuex";
import { appBackMethods } from "@/CommonDP/pages/appView/utils";
import flowService from "@/CommonDP/service/flow-service";

export default {
  name: "InitiateApproval",
  props: {
    // 是否是项目内审批
    isProject: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tabData: [],
      approvalBg: require("@/CommonDP/assets/approval_bg.jpg"),
      active: 0,
      offsetHeight: 0 // 吸顶距离
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    offsetTop() {
      return !this.isProject ? this.offsetHeight + 44 : this.offsetHeight + 90;
    }
  },
  mounted() {
    this.getflowList();
    this.handleResize();
    // this.initEvent();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {

    // 获取 发起审批流程 模块
    async getflowList() {
      const url = flowService[this.requestUrl()];
      const { data } = await url(this.enterpriseId, this.prjInfo.prjCategoryId || "", this.prjInfo.prjId);
      this.tabData = data || [];
    },
    requestUrl() {
      return !this.isProject ? "queryGroupInfoList" : "queryGroupPrjList";
    },
    // 进入流程框架
    async goApproval(row) {
      const { currentVersionId, flowKey } = row;
      const data = { currentVersionId, flowKey, approveType: "add", enterpriseId: this.enterpriseId };
      const routeUrl = this.$router.resolve({ path: "/flowH5Summary", query: data });
      window.open(routeUrl.href, '_blank');
    },
    // 已取消
    async checkCanStart(row) {
      const json = {
        flowKey: row.flowKey,
        flowDefinitionId: row.flowDefinitionId,
        enterpriseId: this.enterpriseId,
        prjId: this.prjInfo?.prjId
      };
      await flowService.checkCanStart(json);
      return true;
    },

    // 返回
    onClickLeft() {
      appBackMethods();
    },
    onClickRight() {
      console.log("点击右侧按钮");
    },
    showIcon(iconPrefix) {
      return require(`@/CommonDP/assets/xunhun/${Number(iconPrefix) || 0}.png`);
    },
    // 窗口大小改变事件
    handleResize() {
      const element = this.$refs.vanImage; // 获取到元素对象
      if (element?.offsetHeight) this.offsetHeight = element.offsetHeight;
    }
  }
};
</script>
<style lang="scss" scoped>
.approval-nav {
  height: 45px;
  width: 100%;
}
.approval-bg {
  height: 24vh;
  width: 100%;
  overflow: hidden;
}
.approval-main {
  height: calc(100vh - 105px - 24vh);
  width: 100%;
  overflow: auto;
}
.main-tabs {
  padding: 0 20px;
  font-size: 14px;
  background: #fff;
  .tabs-title {
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #2a2a2a;
    font-size: 16px;
  }
  .grid-name {
    width: 90px;
    text-align: center;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    color: #444340;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    white-space: nowrap; //溢出不换行
  }
}
::v-deep .van-tabs__content {
  margin-top: 10px;
}

::-webkit-scrollbar {
  display: none;
}
</style>
